var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 95,
    viewBox: "0 0 77 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.3081 50.4368C64.4409 64.8037 76.8624 69.5846 77 69.6457C76.895 69.9828 75.0153 76.459 70.4558 83.1484C66.5143 88.9317 62.4236 94.6938 55.9795 94.8131C49.6476 94.9303 47.6115 91.0435 40.3723 91.0435C33.1352 91.0435 30.8731 94.6938 24.8792 94.9303C18.659 95.1666 13.9224 88.6764 9.94816 82.9142C1.82733 71.1276 -4.37866 49.608 3.95442 35.0819C8.09412 27.8682 15.4921 23.3002 23.5219 23.1831C29.6299 23.0661 35.3952 27.3085 39.1291 27.3085C42.8607 27.3085 49.8668 22.2066 57.2319 22.9559C60.3153 23.0848 68.9702 24.2063 74.5278 32.373C74.08 32.6517 64.2007 38.4255 64.3081 50.4368V50.4368ZM52.4079 15.158C55.7102 11.145 57.9329 5.55852 57.3265 0C52.5664 0.192062 46.8104 3.18442 43.3961 7.19523C40.3363 10.747 37.6565 16.4318 38.3796 21.8803C43.6852 22.2924 49.1054 19.1736 52.4079 15.158",
    fill: "#B9B9B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d0119f1b22ed232e8913ffde6bcdfbb6.svg";
export { ForwardRef as ReactComponent };